import { Component, inject, signal } from '@angular/core';
import { CacTableComponent, table, TableClass } from '@controladad/ng-base';
import { AuthStore, RailsApiService } from '@core';
import { RailEntity } from '@models';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lib-rails',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './rails.component.html',
  styleUrl: './rails.component.scss',
})
export class RailsComponent {
  private readonly railsApi = inject(RailsApiService);
  private readonly authStore = inject(AuthStore);

  table: TableClass<RailEntity> = table({
    itemsFn: () => this.railsApi.getRails().pipe(
      map(result => result.rails)
    ),
    pagination: false,
    view: {
      itemName: 'Rail',
    },
    columns: {
      id: {
        label: 'ID',
        sortable: false
      },
      'name.english': {
        label: 'Name (English)',
        sortable: false,
      },
      'name.arabic': {
        label: 'Name (Arabic)',
        sortable: false,
      },
      priority: {
        label: 'Position',
        sortable: false,
      },
      isActive: {
        label: 'Status',
        type: 'tag',
        items: [
          { value: true, label: 'Active' },
          { value: false, label: 'Inactive' },
        ],
        sortable: false,
      },
      notEditable: {
        label: 'Type',
        type: 'tag',
        items: [
          { value: true, label: 'System' },
          { value: false, label: 'Custom' },
        ],
        sortable: false,
      },
      productIds: {
        label: 'Products',
        transform: (val: number[]) => val?.length || 0,
        sortable: false,
      },
    },
    actions: [
      {
        type: 'icon' as const,
        content: 'edit',
        action: (item: RailEntity) => dialog$.rail({ rail: item }).afterSubmit(),
      },
      ...(!this.authStore.isRestrictedAdmin() ? [{
        type: 'icon' as const,
        content: 'trash',
        action: (item: RailEntity) => {
          if (item.notEditable) {
            snackbar$.error('System rails cannot be deleted');
            return;
          }
          return dialog$
            .deletePrompt(false, { itemName: item.name.english || 'Rail' })
            .action(() => this.railsApi.deleteRail(item.id!));
        },
      }] : []),
    ],
    events: {
      add: () => dialog$.rail().afterSubmit(),
    },
  });
}
